export default __webpack_public_path__ + "static/media/logo-tagline.01764f0e.png";